// **React Imports
import { memo, useEffect, useState } from 'react'

// **MUI Imports
import { Box, CircularProgress, Typography } from '@mui/material'

// **SCSS Imports
import './index.scss'

// ** sub message List
const SUB_MESSAGES = [
  'Analyzing your inputs',
  'Structuring the content',
  'Refining the details',
  'Almost there'
]

const OverlayLoading = ({
  text,
  subMessages = SUB_MESSAGES,
  isPollingMessage = false
}) => {
  const [subIndex, setSubIndex] = useState(0)

  useEffect(() => {
    if (!subMessages?.length) return

    const interval = setInterval(() => {
      setSubIndex((prev) => (prev + 1) % subMessages?.length)
    }, 2500)

    return () => {
      clearInterval(interval)
    }
  }, [subMessages])

  return (
    <Box className="loading-container">
      <CircularProgress />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {text && (
          <Typography
            sx={{
              color: 'var(--common-white)',
              fontSize: '14px',
              fontWeight: 500
            }}
          >
            {text}
          </Typography>
        )}

        {isPollingMessage && (
          <Typography
            key={subIndex}
            className="loading-container-submessage"
            sx={{
              color: 'var(--grey-300)',
              fontSize: '12px',
              fontWeight: 400,
              textAlign: 'center'
            }}
          >
            {subMessages[subIndex]}
          </Typography>
        )}
      </Box>
    </Box>
  )
}

export default memo(OverlayLoading)
